module.exports = "https://cdn.realtymogul.com/static/media/collapse.616886e3.svg";